export default __webpack_public_path__ + "static/accents-mixing-colors-do-light-7880fff2210ead7d8e1b566722064cd42be6be5d93290724886af756b03f5a64.png";